<template>
    <div class="hero-section">
      <div class="hero-image" :style="heroStyle">
        <div class="hero-overlay">
          <h1>Curated Cocktail Recipes for Every Occasion</h1>
          <p>Find your perfect drink and explore hundreds of curated recipes!</p>
          <!-- Updated button text and routing -->
          <router-link to="/all-cocktails" class="cta-button">Start Exploring</router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import heroImage from '@/assets/images/hero-image.jpg';
  
  export default {
    data() {
      return {
        heroStyle: {
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          height: '400px', // Adjust height for better fit
          maxHeight: '500px', // Max height to prevent it from growing too large
        },
      };
    },
  };
  </script>
  
  <style scoped>
  .hero-section {
    width: 100%;
    position: relative;
  }
  
  .hero-image {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }
  
  .hero-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    background: rgba(0, 0, 0, 0.5);
    padding: 20px;
    border-radius: 10px;
  }
  
  .hero-overlay h1 {
    font-size: 3rem;
    margin-bottom: 20px;
  }
  
  .hero-overlay p {
    font-size: 1.5rem;
    margin-bottom: 30px;
  }
  
  .cta-button {
    padding: 10px 20px;
    background-color: #f39c12;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-size: 1rem;
  }
  
  .cta-button:hover {
    background-color: #e67e22;
  }
  </style>
  